import { render } from "./friends_timeline.vue?vue&type=template&id=22490669"
import script from "./friends_timeline.js?vue&type=script&lang=js"
export * from "./friends_timeline.js?vue&type=script&lang=js"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__